import React from 'react'
import { AppShell } from '@mantine/core'
import HeroSection from './components/HeroSection'
import ScenariosSection from './components/ScenariosSection'
import FeaturesSection from './components/FeaturesSection'
import ProcessSection from './components/ProcessSection'
import SupportSection from './components/SupportSection'
import ComplianceSection from './components/ComplianceSection'
import CTASection from './components/CTASection'
import Footer from './components/Footer'

export default function Home() {
  return (
    <AppShell>
      <AppShell.Main>
        <HeroSection />
        <ScenariosSection />
        <FeaturesSection />
        <ProcessSection />
        <SupportSection />
        <ComplianceSection />
        <CTASection />
        <Footer />
      </AppShell.Main>
    </AppShell>
  )
}
